import { MarketingClientSWFBase } from "./marketing-client-swf-base";
import { Utilization } from "./marketing-client-utilization";
import { MarketingClientConstants } from "./constants/marketing-client-constants";
import { EventType } from "./constants/event-type-constants";
import { DOMHelper } from "./helpers/dom-helper";
import { LayerType } from "./helpers/swf-helper";

export class MarketingClientShareArticle extends MarketingClientSWFBase {
  wyborczaCapClass: "cap";
  shareArticleLayersId = "shareArticleLayers";
  modalBoxClass = ".nw_2021_modal-box";
  modalButtonClass = ".button-wrapper button";

  constructor(public utilizationObject: Utilization) {
    super(utilizationObject);
  }

  init() {
    this.initialize();
    this.appendLayersToBody();
    this.bindEvents();
  }

  appendLayersToBody() {
    const shareArticleLayers = DOMHelper.getElementById(this.shareArticleLayersId);
    if (!shareArticleLayers) return;

    document.body.appendChild(shareArticleLayers);
  }

  bindEvents() {
    this.bindEventsToModals();
    this.bindEventsToFormSubmit();
    this.bindEventsToEmailInput();
  }

  bindEventsToModals() {
    if (!this.form) return;

    DOMHelper.querySelectorAsArray(this.modalButtonClass).forEach((modalButton) => {
      modalButton?.addEventListener(EventType.CLICK, () => {
        if (this.form) {
          this.form.reset();
        }

        this.errorHandler.hide();
        this.showLayer(LayerType.DEFAULT);
      });
    });

    window.addEventListener(EventType.CLICK, ({ target }) => {
      const elementClassList = Array.from((target as Element)?.classList);
      const isModalBox = elementClassList.includes(this.modalBoxClass.replace(".", ""));

      if (!isModalBox) return;
      this.hideLayers();
    });
  }

  showLayer(layer = LayerType.DEFAULT) {
    DOMHelper.querySelectorAsArray(this.modalBoxClass).forEach((modal) => {
      modal.classList.add(MarketingClientConstants.hiddenClassName);
    });

    this.layers[layer]?.classList.remove(MarketingClientConstants.hiddenClassName);
  }

  hideLayers() {
    DOMHelper.querySelectorAsArray(this.modalBoxClass).forEach((modal) => {
      modal.classList.add(MarketingClientConstants.hiddenClassName);
    });
  }

  successResponseHandler(response: any) {
    if (response.data.status) {
      this.showLayer(LayerType.SUCCESS);
    } else if (response.data.result === LayerType.BLOCKED.toUpperCase()) {
      this.showLayer(LayerType.BLOCKED);
    }
  }

  errorResponseHandler() {
    this.showLayer(LayerType.ERROR);
  }

  scrollToLayer(layer: HTMLElement) {
    let layerTop = layer.offsetTop,
      cap = DOMHelper.querySelector(this.wyborczaCapClass) as HTMLElement,
      capHeight = cap?.offsetHeight || 0,
      scrollTop = window.scrollY + capHeight;

    if (layerTop < scrollTop) {
      window.scrollTo({
        top: layerTop - capHeight - 20,
        behavior: "smooth"
      });
    }
  }
}
